import React from "react";
import { connect } from 'react-redux';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// material-ui icons
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { formatStatus } from "../../utils/helpers";

class JobCardTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  jobAge(date1) {

    const createdDate = this.formatDate(date1)
    const dateNow = this.formatDate(this.getDateNow())

    const ONE_DAY = 1000 * 60 * 60 * 24;

    const differenceMs = Math.abs(createdDate.getTime() - dateNow.getTime());

    return Math.round(differenceMs / ONE_DAY) + " days";

  }

  formatDate(date) {
    const d = date.substring(0, 10)

    const year = d.substring(0, 4)
    const month = d.substring(5, 7)
    const day = d.substring(8, 10)
    return new Date(year, month, day);
  }

  getDateNow() {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();

    return yyyy + '-' + mm + '-' + dd;

  }

  render() {
    const { classes } = this.props;
    let jobCards = this.props.jobCards || [];
    const StatusArray = this.props.status

    jobCards = jobCards.filter(x => StatusArray.includes(x.status)    );
    if (this.props.showJobAge || this.props.failedExecutionExternalWorkspace) {
      jobCards = jobCards.map((prop, key) => {
        return [prop.jobCardNumber, (this.props.failedExecutionExternalWorkspace ? prop.createdAt : this.jobAge(prop.createdAt)), formatStatus(prop.type),
        formatStatus(prop.status), prop.project.name, prop.stand.town,
        this.props.actionButtons(this.props.viewJobCard.bind(this, prop.jobCardNumber))

        ]
      });
    } else {
      jobCards = jobCards.map((prop, key) => {
        return [prop.jobCardNumber, prop.createdAt, formatStatus(prop.type),
        prop.project.name, prop.stand.town,
        this.props.actionButtons(this.props.onClickFn2.bind(this, prop._id, prop.jobCardNumber), this.props.viewJobCard.bind(this, prop.jobCardNumber)),

        ]
      });
    }



    const jobAgeTableHeaders = ["Job Card No", 'Job Age', "Job Type", "Job Status", "Project", "Town", "Actions"]
    const tableHeaders = ["Job Card No", 'Created At', "Job Type", "Project", "Town", "Actions"]

    return (
      <GridContainer>
        <GridItem xs={12}>
          <Table
            tableHead={((this.props.showJobAge) ? jobAgeTableHeaders : tableHeaders)}
            tableData={jobCards}
            customCellClasses={[
              classes.center,
              classes.center,
              classes.center
            ]}
            customClassesForCells={[0, 4, 5]}
            customHeadCellClasses={[
              classes.center,
              classes.center,
              classes.center
            ]}
            customHeadClassesForCells={[0, 4, 5]}
          />

        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(extendedTablesStyle)(JobCardTable);
